import { cloneDeep } from 'lodash';

import {
    RecommendationsGridAction,
    UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA,
    UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS,
    UPDATE_RECOMMENDATIONS_GRID_SUMMARY,
    UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS,
    UPDATE_RECOMMENDATIONS_ITEMS
} from '../actions/recommendations-grid';
import { getDefaultDynamicDailyBudgetRecommendationsColumns } from '../declarations/dailyBudgetRecommendations/dailyBudgetRecommendations';
import { getDefaultDynamicRemovePagesFromBlackListRecommendationsColumns } from '../declarations/removePagesFromBlackListRecommendations/removePagesFromBlackListRecommendations';
import { getDefaultDynamicSwitchOnAutotargetingRecommendationsColumns } from '../declarations/switchOnAutotargetingRecommendations/switchOnAutotargetingRecommendations';
import { ColumnsHelpers } from '../service/ColumnsHelpers/ColumnsHelpers';
import { LocalStorage, StorageKeyType } from '../service/Storage/Storage';
import { ColumnsSettingsViewDict } from '../typings/common';
import { CurrencyCode } from '../typings/graphql-grid';
import { defaultRowsCount } from '../typings/grid';
import { RecommendationsGridItem, RecommendationType } from '../typings/recommendations';
import { RecommendationsGridState, State } from '../typings/state';

export const recommendationsGridInitialState = {
    gridData: {
        total: defaultRowsCount,
        allItemsIds: [],
        data: []
    },
    recommendationsGridReqId: '',
    columnsSettings: ColumnsHelpers.getColumns(
        {
            [RecommendationType.dailyBudget]: getDefaultDynamicDailyBudgetRecommendationsColumns(),
            [RecommendationType.removePagesFromBlackList]: getDefaultDynamicRemovePagesFromBlackListRecommendationsColumns(),
            [RecommendationType.switchOnAutotargeting]: getDefaultDynamicSwitchOnAutotargetingRecommendationsColumns()
        },
        LocalStorage.getItem(StorageKeyType.recommendationSettings) as ColumnsSettingsViewDict
    ),
    isHorizontalScrollVisible: true,
    isHeaderVisible: true,
    clientInfo: {
        enabledRecommendationTypes: [],
        workCurrency: CurrencyCode.RUB
    }
};

export function recommendationsGrid(
    state: RecommendationsGridState = recommendationsGridInitialState,
    action: RecommendationsGridAction,
    fullState: State
): RecommendationsGridState {
    switch (action.type) {
        case UPDATE_RECOMMENDATIONS_ITEMS:
            return {
                ...state,
                gridData: action.gridData,
                clientInfo: action.clientInfo,
                recommendationsGridReqId: action.recommendationsGridReqId
            };

        case UPDATE_RECOMMENDATIONS_GRID_DATA_ITEM_STATUS:
            return {
                ...state,
                gridData: {
                    ...state.gridData,
                    data: state.gridData.data.map((dataItem: RecommendationsGridItem) => {
                        if (dataItem.id === action.id) {
                            return {
                                ...dataItem,
                                status: action.status
                            };
                        } else {
                            return dataItem;
                        }
                    })
                }
            };

        case UPDATE_RECOMMENDATIONS_COLUMNS_WIDTH_DATA:
            return {
                ...state,
                columnsSettings: cloneDeep(action.columns)
            };

        case UPDATE_RECOMMENDATIONS_GRID_SUMMARY:
            return {
                ...state,
                summaryRecommendationData: action.summaryRecommendationData
                    ? action.summaryRecommendationData
                    : undefined
            };

        case UPDATE_RECOMMENDATIONS_GRID_SUMMARY_STATUS:
            return {
                ...state,
                summaryRecommendationData: state.summaryRecommendationData && {
                    ...state.summaryRecommendationData,
                    status: action.status
                }
            };

        default:
            return state;
    }
}
